import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IconComponent } from '@app/components/shared/icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';
import { FileErrorDialogData } from '@app/utils/interfaces/file-error-dialog-data.interface';

export enum FileErrorDialogType {
  Upload = 'Upload',
  Export = 'Export',
}

@Component({
  selector: 'app-file-error-modal',
  standalone: true,
  imports: [IconComponent, TranslatePipe],
  templateUrl: './file-error-modal.component.html',
  styleUrl: './file-error-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileErrorModalComponent {
  private readonly dialogRef = inject(MatDialogRef<FileErrorModalComponent>);
  public readonly data = inject<FileErrorDialogData>(MAT_DIALOG_DATA);
  public readonly IconName = IconName;
  public readonly FileErrorDialogType = FileErrorDialogType;

  public close(): void {
    this.dialogRef.close();
  }

  public action(): void {
    this.data.actionButtonCallback();
    this.dialogRef.close();
  }
}
